import React, { Suspense } from 'react';

import { closeNotPremiumModal } from '@redux/layout';
import { isNotPremiumModalOpenSelector } from '@redux/layout/selectors';
import { useDispatch, useSelector } from 'react-redux';

import Loader from 'components/shared/Loader';
import { isAndroidBefore10, isBrowserCompatible } from 'services/helpers/browser';
import { lazyWithRetry } from 'services/helpers/lazyWithRetry';

import { FreeTrialEndMessage, NotPremiumMessage } from '../CannotPlaySongModal/CannotPlaySongModal';

const AndroidNotCompatibleModal = lazyWithRetry(() => import('../AndroidNotCompatibleModal'));
const BrowserNotCompatibleModal = lazyWithRetry(() => import('../BrowserNotCompatibleModal'));
const CannotPlaySongModal = lazyWithRetry(() => import('../CannotPlaySongModal'));

interface Props {
  isTrialEndDisplayed: boolean;
  hideTrialEnd: () => void;
}

const MobileModal: React.FC<Props> = ({ isTrialEndDisplayed, hideTrialEnd }) => {
  const dispatch = useDispatch();
  const isNotPremiumModalOpen = useSelector(isNotPremiumModalOpenSelector);

  return (
    <Suspense fallback={<Loader />}>
      {isAndroidBefore10() ? (
        <AndroidNotCompatibleModal />
      ) : !isBrowserCompatible() ? (
        <BrowserNotCompatibleModal />
      ) : (
        <>
          <CannotPlaySongModal
            isOpen={isTrialEndDisplayed}
            onClose={hideTrialEnd}
            Message={FreeTrialEndMessage}
          />
          <CannotPlaySongModal
            isOpen={isNotPremiumModalOpen}
            onClose={() => dispatch(closeNotPremiumModal())}
            Message={NotPremiumMessage}
          />
        </>
      )}
    </Suspense>
  );
};

export default MobileModal;
